import { styled } from '@mui/material';
import { PauseButton } from '@components/PauseButton';

export const V2PauseButton = styled(PauseButton)({
  zIndex: 30,
});